let css = require('./radio.css');
const RADIO = `.${css.radio}`;

class Radio {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => {
            let attributes = this.$context.attributes;
            return Object.assign({}, data, attributes, { css });
        });
    }

    bind () {
        return {
            change: {
                [RADIO]: this.onChange
            }
        };
    }

    onChange (e) {
        e.stopPropagation();

        let signal = this.$context.props.signal;
        let key = this.$context.attributes['cat-key'];
        let value = e.currentTarget.checked;

        this.$context.signal(signal, { key, value });
    }
}

module.exports = {
    constructor: Radio
};



// WEBPACK FOOTER //
// ./packages/account-ui/radio/index.js